import { send } from 'server';

export const fetchLimits = () => send({
    ID: 35622,
    responses: [35623, 35624],
    description: 'Get Player Login Limits'
});

export const saveLimits = (limits = {}) => send({
    ...limits,
    ID: 35625,
    responses: [35626, 35627],
    description: 'Set Player Login Limits'
});
